import { Button } from 'react-bootstrap';

import { useProvider, Toast } from '../../context/MenuProvider';


const MenuRodape = ({ venda, botao }) => {
  const { crud } = useProvider();
  const { loading } = crud ||{};
  if (!venda || parseFloat(venda.quantidade || 0) <= 0) return null;

  const totalComDesconto = parseFloat(venda.total || 0) - parseFloat(venda.desconto || 0);
  const totalComDescontoFormatado = totalComDesconto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const totalOriginal = parseFloat(venda.total || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  
  return (
    <div className="bs-floating shadow navbar-light">
      <div id="btnAddCkFecharVenda" className="container py-2">
        <div className="row align-items-center">
          <div className="col">
            <div className="d-flex w-100 justify-content-between">
              Total de {venda.quantidade} ite{venda.quantidade > 1 ? 'ns' : 'm'}
            </div>
          </div>
          <div className="col-auto">
            <div className="fs-4">
              {parseFloat(venda.desconto || 0) > 0 && (
                <s className="text-muted fs-6 pb-3">{totalOriginal}</s>
              )}
              {totalComDescontoFormatado}
            </div>
          </div>
        </div>
        {botao && (
          <Button variant="secondary" onClick={botao.onClick} className="w-100 btn-lg">
            {botao.text}
          </Button>
        )}
      </div>
    </div>
  );
};

export default MenuRodape;